import React from 'react';
import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './NoOnlineOrdersMessage.st.css';
import {useControllerProps} from '../Widget/ControllerContext';
import {NoOnlineOrdersActions} from './NoOnlineOrdersActions';
import {getNoOnlineOrdersParams} from './NoOnlineOrdersMessage.utils';

export enum NoOnlineOrdersMessageDataHooks {
  Root = 'NoOnlineOrdersMessageDataHooks.Root',
  CloseIcon = 'NoOnlineOrdersMessageDataHooks.CloseIcon',
  BadgeIcon = 'NoOnlineOrdersMessageDataHooks.BadgeIcon',
  AlertIcon = 'NoOnlineOrdersMessageDataHooks.AlertIcon',
  Title = 'NoOnlineOrdersMessageDataHooks.Title',
  Message = 'NoOnlineOrdersMessageDataHooks.Message',
}

export interface NoOnlineOrdersMessageProps {
  onDismissNoPremiumError: () => void;
}

export const NoOnlineOrdersMessage = ({onDismissNoPremiumError}: NoOnlineOrdersMessageProps) => {
  const {
    isLoading,
    checkoutSettingsStore: {cannotShip, isPremium},
    navigationStore: {isOwnerOrPreview, upgradeUrlWithModalReferral, shippingSettingsUrlWithModalReferral},
  } = useControllerProps();

  const hasNoPremium = !isLoading && !isPremium;
  const localeKeys = useLocaleKeys();
  const {title, body, Icon, iconDataHook, actionParams} = getNoOnlineOrdersParams({
    cannotShip,
    isOwnerOrPreview,
    localeKeys,
    upgradeUrlWithModalReferral,
    shippingSettingsUrlWithModalReferral,
    onDismissNoPremiumError,
    hasNoPremium,
  });

  return (
    <div data-hook={NoOnlineOrdersMessageDataHooks.Root} className={classes.root}>
      <div data-hook={iconDataHook} className={classes.closeIcon}>
        <Icon size={28} />
      </div>
      <Text data-hook={NoOnlineOrdersMessageDataHooks.Title} className={classes.titleText}>
        {title}
      </Text>
      <Text data-hook={NoOnlineOrdersMessageDataHooks.Message} typography={TextTypography.runningText}>
        {body}
      </Text>
      {actionParams && (
        <div className={classes.actions}>
          <NoOnlineOrdersActions actionParams={actionParams} />
        </div>
      )}
    </div>
  );
};
